const TextArea = (props) => (
    <textarea 
    onChange={(e) => props.change(e.target.value)}
    className={"border-2 border-black h-4/6 rounded-lg p-5 " + props.className + " resize-none"} 
    />
)

export default TextArea